angular.module('umCore').constant('gridColumnConstant', {
    SUBMISSION_HOME_PAGE_INSURED: 'Insured',
    SUBMISSION_HOME_PAGE_ACCOUNT_NAME: 'Account Name',
    SUBMISSION_HOME_PAGE_SUBMISSION: 'Submission',
    SUBMISSION_HOME_PAGE_EFFECTIVE: 'Effective',
    SUBMISSION_HOME_PAGE_EXPIRATION: 'Expiration',
    SUBMISSION_HOME_PAGE_STATUS: 'Status',
    SUBMISSION_HOME_PAGE_STATUS_REASON: 'Status Reason',
    SUBMISSION_HOME_PAGE_PREMIUM: 'Premium',
    SUBMISSION_HOME_PAGE_NEXT_ACTION: 'Next Action',
    SUBMISSION_HOME_PAGE_ACTION_DATE: 'Action Date',
    SUBMISSION_HOME_PAGE_ASSIGNED_TO: 'Assigned To',
    SUBMISSION_HOME_PAGE_UNDERWRITER: 'Underwriter',
    SUBMISSION_HOME_PAGE_COVERAGE: 'Coverage',
    SUBMISSION_HOME_PAGE_AGENCY: 'Agency',
    SUBMISSION_HOME_PAGE_PRODUCT: 'Product',
    SUBMISSION_HOME_PAGE_RECEIVED_DATE: 'Received Date',
    SUBMISSION_HOME_PAGE_NEEDED_BY_DATE: 'Needed By Date',
    SUBMISSION_HOME_PAGE_PRIORITY: 'Priority',
    SUBMISSION_HOME_PAGE_RISK_STATE: 'Risk State',
    SUBMISSION_HOME_PAGE_TOTAL_LIMIT: 'Total Limit',
    SUBMISSION_HOME_PAGE_OBLIGATION_NAME: 'Name of Obligation',
    SUBMISSION_ACCOUNT_PAGE_INSURED: 'Insured',
    SUBMISSION_ACCOUNT_PAGE_EFFECTIVE: 'Effective',
    SUBMISSION_ACCOUNT_PAGE_EXPIRATION: 'Expiration',
    SUBMISSION_ACCOUNT_PAGE_STATUS: 'Status',
    SUBMISSION_ACCOUNT_PAGE_STATUS_REASON: 'Status Reason',
    SUBMISSION_ACCOUNT_PAGE_PREMIUM: 'Premium',
    SUBMISSION_ACCOUNT_PAGE_NEXT_ACTION: 'Next Action',
    SUBMISSION_ACCOUNT_PAGE_ASSIGNED_TO: 'Assigned To',
    SUBMISSION_ACCOUNT_PAGE_RISK_STATE: 'Risk State',
    SUBMISSION_ACCOUNT_PAGE_TOTAL_LIMIT: 'Total Limit',
    SUBMISSION_ACCOUNT_PAGE_OBLIGATION_NAME: 'Name of Obligation',
    SUBMISSION_ACCOUNT_PAGE_COVERAGE: 'Product',
    SUBMISSION_ACCOUNT_PAGE_SUBMISSION: 'Submission #',
    SUBMISSION_ACCOUNT_PAGE_RECEIVED_DATE: 'Date Received',
    SUBMISSION_ACCOUNT_PAGE_ACTION_DATE: 'Next Action Due Date',
    SUBMISSION_ACCOUNT_PAGE_AGENCY: 'Agency/Brokerage',
    TASK_GRID_RESOLVED: 'Resolved',
    TASK_GRID_DUE_DATE: 'Due Date',
    TASK_GRID_TASK_SUMMARY: 'Task Summary',
    TASK_GRID_ASSIGNED_BY: 'Assigned By',
    TASK_GRID_TASK_DETAILS: 'Task Details',
    TASK_GRID_EFFECTIVE_DATE: 'Effective Date',
    TASK_GRID_CREATED_DATE: 'Assigned Date',
    TASK_GRID_RESOLVED_DATE: 'Resolved Date'
});
